// extracted by mini-css-extract-plugin
module.exports = {"transition":"_4c0fb08a"};